export default "__VITE_ASSET__kb6jPs5B__"